import {roomGroupApi} from "@/core/api/room.group.api";
import {RoomCall} from "@/core/api/room.call.api";

import _ from 'lodash'

export default {
    createRoomGroup: ({ dispatch, commit, getters, rootGetters }, {roomGroupList}) => {
        return roomGroupApi.createRoomGroup(roomGroupList)
    },
    startRoomGroup: ({ dispatch, commit, getters, rootGetters }, {roomGroupList, useContentLayout, hideRoomGroupUserInFilmArea}) => {
        return roomGroupApi.startRoomGroup({roomGroupList, useContentLayout, hideRoomGroupUserInFilmArea})
    },
    createAndStartRoomGroup: ({ dispatch, commit, getters, rootGetters }, {roomGroupList, useContentLayout, hideRoomGroupUserInFilmArea}) => {
        return roomGroupApi.createAndStartRoomGroup({roomGroupList, useContentLayout, hideRoomGroupUserInFilmArea})
    },
    endRoomGroup: async ({ dispatch, commit, getters, rootGetters }, {isNextSchedule = false, layoutType, roomMode = 'doc'} = false) => {
        if (!rootGetters['user/isOpener']()
            && rootGetters['user/isParticipantRole']()) {
          return setTimeout(() => {
            dispatch('common/setAlert', {
              text: '학습자는 그룹토의를 종료할 수 없습니다.',
              onlyOk: true
            }, { root: true });
          }, 0);
        }

        await roomGroupApi.endRoomGroup(roomMode === 'doc' ? getters.selectedPin : '');
        
        if (getters.selectedPin && roomMode === 'note') {
          const shareNoteLogs = await dispatch('shareNote/shareNoteLogList', null, { root: true });
          const shareNote = shareNoteLogs.find(snl => snl.roomGroupId === getters.selectedPin);
          if (!shareNote) return;

          const noteId = shareNote.noteId;
          await dispatch('shareNote/changeRoomShareNote', { noteId }, { root: true });
        }

        if (!isNextSchedule) {
          await dispatch('room/changeRoomMode', { roomMode }, { root: true });
          await dispatch('room/changeMixingLayoutType', layoutType ? { layoutType } : {}, { root: true });
          
          if (getters.selectedPin) {
            await dispatch('changeMixingVideoChannelByUserId');
            dispatch('setSelectedPin', '');
          }
        }
    },
    addRoomGroup: async ({ dispatch, commit, getters, rootGetters }, roomGroupList) => {
        return roomGroupApi.addRoomGroup(roomGroupList)
    },
    removeRoomGroup: async ({ dispatch, commit, getters, rootGetters }, roomGroupList) => {
        return roomGroupApi.removeRoomGroup(roomGroupList)
    },
    changeMixingVideoChannelByUserId: ({ dispatch, commit, getters, rootGetters }) => {
      const selectedUserIdList = getters.selectedUserIdList
      selectedUserIdList.slice(0,6).forEach((userId, index) => {
        RoomCall.Mixer.changeMixingVideoChannelByUserId(
          { userId,
            channel: 12 + index
          }
        )
      })

      selectedUserIdList.length && dispatch('setSelectedUserIdList', []);
    },
    eraseRoomGroupUser: ({ dispatch, commit, getters, rootGetters }, {userId, roomGroupId}) => {
        return roomGroupApi.eraseRoomGroupUser({userId, roomGroupId})
    },
    setRoomUserGroup: async ({ dispatch, commit, getters, rootGetters }, {roomGroupId, userId}) => {
        return await roomGroupApi.setRoomUserGroup({roomGroupId, userId})
    },
    regRoomGroupSubject: ({ dispatch, commit, getters, rootGetters }, roomGroupSubjectList) => {
        return roomGroupApi.regRoomGroupSubject(roomGroupSubjectList)
    },
    removeNoteSubject: ({ dispatch, commit, getters, rootGetters }, roomGroupId) => {
        return roomGroupApi.removeRoomGroupSubject(roomGroupId)
    },
    addRoomGroupsDurationTime: ({ dispatch, commit, getters, rootGetters }, roomGroupDtoList) => {
        return roomGroupApi.addRoomGroupsDurationTime(roomGroupDtoList)
    },
    changeRoomGroupState: ({ dispatch, commit, getters, rootGetters }, {roomGroupId, state}) => {
        return roomGroupApi.changeRoomGroupState({roomGroupId, state})
    },
    changeRoomGroupMuteState: async ({ dispatch, commit, getters, rootGetters }, params) => {
        const roomGroup = rootGetters["roomGroup/getRoomGroup"](params.roomGroupId);
        if (!roomGroup) {
          console.warn('roomGroup is null :', params.roomGroupId);
          return;
        }

        return await roomGroupApi.changeRoomGroupMuteState({
            roomGroupId: params.roomGroupId,
            state : !roomGroup.speakerMuteState && roomGroup.speakerMuteState !== undefined
        });
    },
    setNewUser: ({ dispatch, commit, getters, rootGetters }, newStatus) => {
        commit('SET_NEW_USER', newStatus)
    },
    setSelectedPin: ({ dispatch, commit, getters, rootGetters }, value) => {
        commit('SET_SELECTED_PIN', value)
    },
    setSelectedUserIdList: ({ dispatch, commit, getters, rootGetters }, userIdList) => {
        commit('SET_SELECTED_USER_ID_LIST', userIdList)
    },
    setLoadingGroupMode: ({ dispatch, commit, getters, rootGetters }, loadingGroup) => {
        commit('SET_LOADING_GROUP_MODE', loadingGroup)
    },
    finishLoadingGroup: ({ dispatch, commit, getters, rootGetters }, roomGroupId) => {
        commit('FINISH_LOADING_GROUP', roomGroupId)
    },

    // With Schedule
    createRoomGroupWithSchedule({ dispatch, commit, getters, rootGetters }, schedule) {
        if ("group" != schedule.scheduleType || !schedule.lectureScheduleGroupList) {
          console.warn("# not schedule group ", schedule);
          return
        }

        let mode = "EditDoc" == schedule.groupDiscussionType ? 'note' : 'doc'
        let roomGroupList = []
        let setRandomUser = "Random" == schedule.groupDivisionType
        schedule.lectureScheduleGroupList.forEach(scheduleGroup => {
          roomGroupList.push({
            groupName: scheduleGroup.groupName,
            roomGroupId: 'group-' + scheduleGroup.groupSequence,
            roomGroupIndex: scheduleGroup.groupSequence,
            subject: scheduleGroup.sharedSubject,
            subjectDescription: scheduleGroup.sharedDescription,
            mode: mode,
            userIdList: scheduleGroup.lectureScheduleGroupParticipantsRefList && !setRandomUser
                ? scheduleGroup.lectureScheduleGroupParticipantsRefList.map(user => user.userId)
                : [],
            docId: scheduleGroup.shareFileId,
            durationSeconds: schedule.runningTime * 60
          })
        })

        if (setRandomUser) {
          if ("People" == schedule.groupRandomType) {
            dispatch('createRandomUserRoomGroupListWithSchedule', { roomGroupList, roomUserCount: schedule.groupRandomNumber })
          } else {
            dispatch('createRandomRoomGroupListWithSchedule', roomGroupList)
          }
        }
        console.log('create roomGroupApi roomGroupList ', roomGroupList)
  
        return roomGroupList
      },
      createRandomRoomGroupListWithSchedule({ dispatch, commit, getters, rootGetters }, roomGroupList) {
        let randomUserList = _.shuffle(
            _.cloneDeep(rootGetters['user/roomUserList'])
            .filter(ru => rootGetters['user/isParticipantRole'](ru))
            .map(ru => ru.userId)
        )
  
        let roomGroupListLength = roomGroupList.length - 1
        let roomGroupListIndex = 0
        for (let i = 0 ; i < randomUserList.length; i++ ){
          roomGroupList[roomGroupListIndex].userIdList.push(randomUserList[i])
          roomGroupListIndex = roomGroupListIndex >= roomGroupListLength ? 0 : roomGroupListIndex + 1
        }
  
        return roomGroupList
      },
      createRandomUserRoomGroupListWithSchedule({ dispatch, commit, getters, rootGetters }, { roomGroupList, roomUserCount }) {
        roomUserCount = roomUserCount < 2 ? 2 : roomUserCount
  
        let randomUserList = _.shuffle(
            _.cloneDeep(rootGetters['user/roomUserList'])
            .filter(ru => rootGetters['user/isParticipantRole'](ru))
            .map(ru => ru.userId)
        )
        let roomGroupCount = 0
        while (randomUserList.length) {
          let userIdList = randomUserList.splice(0, roomUserCount)
          if (userIdList.length) {
            roomGroupList[roomGroupCount].userIdList = userIdList
            roomGroupCount  = roomGroupCount >= roomGroupList.length - 1 ? 0 : roomGroupCount + 1
          }
        }
  
        return roomGroupList
    },
    setNewGroup({ dispatch, commit, getters, rootGetters }, status = true) {
      commit('SET_NEW_GROUP', status);
    },
    changeHideRoomGroupUserInFilmArea({dispatch, commit, getters, rootGetters}, hideRoomGroupUserInFilmArea) {
        roomGroupApi.changeHideRoomGroupUserInFilmArea({hideRoomGroupUserInFilmArea});
    },
    changeRoomGroupMicMuteState({dispatch, commit, getters, rootGetters}, data) {
        roomGroupApi.changeRoomGroupMicMuteState(data);
    },
    changeRoomGroupSpeakerMuteState({dispatch, commit, getters, rootGetters}, data) {
        roomGroupApi.changeRoomGroupSpeakerMuteState(data);
    },
}